import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import { AB_API_GET_CREDITCARD_TRANSACTIONS } from './../../shared/constants';
import { IBalance } from '../../shared/interfaces/balance.interface';

interface ICreditCardTransaction {
  id: string;
  date: Date;
  merchant: string;
  country: string;
  amount: IBalance;
}

interface CreditCardTransactionsResponse extends ApiResponse {
  transactions: Array<ICreditCardTransaction>;
  pageSize: number;
}

@Injectable({
  providedIn: 'root'
})
export class CreditCardTransactionsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_GET_CREDITCARD_TRANSACTIONS);
  }

  getTransaction(id: string, pageNumber: number): Observable<CreditCardTransactionsResponse> {
    return this.get({
      id: id,
      pageNumber
    });
  }
}

export { CreditCardTransactionsResponse, ICreditCardTransaction };
